import type { Translations } from './de'

const ru: Translations = {
  'language.flag': '🇷🇺',
  'language.name': 'Русский',
  'navigation.home': 'Главная',
  'navigation.language': 'Язык',
  'navigation.openMenu': 'Открыть меню',
  'navigation.closeMenu': 'Закрыть меню',
  'navigation.skipToContent': 'Перейти к содержимому',
  'categories.sightseeing.name': 'Достопримечательности',
  'categories.sightseeing.heading': 'Самые популярные достопримечательности Аугсбурга',
  'categories.sightseeing.lead': 'От объектов Всемирного наследия ЮНЕСКО до Фуггерай: Аугсбург может предложить больше, чем ты думаешь.',
  'categories.events.name': 'События',
  'categories.events.heading': 'Все события с первого взгляда',
  'categories.events.lead': 'Концерты, рынки, экскурсии по городу: узнай, что происходит в Аугсбурге на этой неделе.',
  'categories.blog.name': 'Новости',
  'categories.blog.heading': 'Новости из Аугсбурга',
  'categories.blog.lead': 'Предыстории, история города и актуальные темы, чтобы читать и рассказывать дальше.',
  'categories.emptyTitle': 'Здесь пока ничего нет',
  'categories.emptyDescription': 'В этом разделе ещё нет страниц. Загляни сюда позже.',
  'home.title': 'Добро пожаловать в Аугсбург',
  'home.intro': 'Городская поездка, деловая командировка или визит к родным: здесь ты найдёшь всю важную информацию для пребывания в Аугсбурге.',
  'home.sightseeing.eyebrow': 'Город Всемирного наследия ЮНЕСКО',
  'home.sightseeing.title': 'Открой достопримечательности',
  'home.sightseeing.lead': 'От объектов Всемирного наследия ЮНЕСКО до Фуггерай: Аугсбург может предложить больше, чем ты думаешь.',
  'home.sightseeing.action': 'Открыть сейчас',
  'home.events.eyebrow': 'Что происходит в Аугсбурге?',
  'home.events.title': 'Найти события',
  'home.events.lead': 'Больше не пропускай концерты, блошиные рынки и фестивали. На нашей странице мероприятий ты всегда в курсе.',
  'home.events.action': 'Все события',
  'home.blog.eyebrow': 'Истории из города',
  'home.blog.title': 'Новости и интересное',
  'home.blog.lead': 'Здесь ты найдёшь всё важное об Аугсбурге, чтобы ничего не упустить во время визита.',
  'home.blog.action': 'В блог',
  'home.language.eyebrow': 'Аугсбург – международный город',
  'home.language.title': 'Перейти на свой язык',
  'home.language.lead': 'Этот сайт доступен на нескольких языках. Хочешь сменить язык?',
  'home.highlights.eyebrow': 'Подобрано для тебя',
  'home.highlights.title': 'Наши рекомендации',
  'home.highlights.lead': 'Для хорошего начала мы собрали для тебя несколько самых интересных мест Аугсбурга. Приятного чтения!',
  'search.placeholder': 'Поиск...',
  'search.clear': 'Очистить поиск',
  'search.label': 'Поиск страниц',
  'search.results': '{{count}} результатов по запросу «{{query}}»',
  'search.emptyTitle': 'Ничего не найдено',
  'search.emptyDescription': 'По этому запросу мы ничего не нашли. Попробуй другое слово.',
  'pagination.label': 'Страницы',
  'pagination.previous': 'Предыдущая страница',
  'pagination.next': 'Следующая страница',
  'pagination.page': 'Страница {{page}}',
  'pagination.summary': '{{start}}–{{end}} из {{total}}',
  'page.back': 'Назад',
  'page.readMore': 'Подробнее',
  'page.tableOfContents': 'На этой странице',
  'page.openInGoogleMaps': 'Открыть в Google Картах',
  'map.copyAddress': 'Копировать адрес',
  'map.copied': 'Скопировано',
  'map.copyFailed': 'Не удалось скопировать',
  'map.routeInGoogleMaps': 'Маршрут в Google Картах',
  'map.zoomIn': 'Приблизить',
  'map.zoomOut': 'Отдалить',
  'map.showAll': 'Показать всё',
  'attribution.toggle': 'Показать или скрыть источники',
  'map.gestures.windows': 'Используйте Ctrl + прокрутку, чтобы масштабировать карту',
  'map.gestures.mac': 'Используйте ⌘ + прокрутку, чтобы масштабировать карту',
  'map.gestures.mobile': 'Перемещайте карту двумя пальцами',
  'map.loading': 'Карта загружается …',
  'map.failed': 'Не удалось загрузить карту.',
  'map.showPlace': 'Показать {{name}} на карте',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'около {{duration}} пешком',
  'map.route.stops': 'Остановок: {{count}}',
  'map.route.leg': '{{distance}} · около {{duration}}',
  'mapIcons.landmark': 'Достопримечательность',
  'mapIcons.church': 'Церковь',
  'mapIcons.museum': 'Музей',
  'mapIcons.park': 'Парк и природа',
  'mapIcons.viewpoint': 'Смотровая площадка',
  'mapIcons.cafe': 'Кафе',
  'mapIcons.bar': 'Бар',
  'mapIcons.restaurant': 'Ресторан',
  'mapIcons.shop': 'Покупки',
  'mapIcons.event': 'Место проведения мероприятий',
  'mapIcons.transport': 'Транспорт',
  'mapIcons.place': 'Место',
  'footer.imprint': 'Выходные данные',
  'footer.privacy': 'Политика конфиденциальности',
  'footer.mediaLicense': 'Права на изображения',
  'legal.bindingNote': 'Этот перевод предоставляется только для информации. Юридически обязательной является только немецкая версия.',
  'imprint.provider.heading': 'Сведения согласно § 5 DDG',
  'imprint.contact.heading': 'Контакт',
  'imprint.contact.email': 'Электронная почта',
  'imprint.responsible.heading': 'Ответственный за содержание согласно § 18 абз. 2 MStV',
  'privacy.intro': 'Эта политика конфиденциальности объясняет, какие персональные данные обрабатываются, когда ты посещаешь этот сайт.',
  'privacy.controller.heading': 'Ответственный за обработку',
  'privacy.controller.text': 'Ответственным за обработку данных на этом сайте является:',
  'privacy.hosting.heading': 'Хостинг',
  'privacy.hosting.text': 'Этот сайт размещён у внешнего хостинг-провайдера с местонахождением в Германии. Серверы находятся в Германии.',
  'privacy.serverLogs.heading': 'Журналы сервера',
  'privacy.serverLogs.text': 'При каждом посещении этого сайта сервер автоматически сохраняет информацию, которую передаёт твой браузер: IP-адрес, дату и время запроса, открытую страницу, объём переданных данных, URL-адрес перехода, а также браузер и операционную систему. Эти данные необходимы для безопасной и стабильной работы сайта (ст. 6 п. 1 подп. f GDPR) и удаляются не позднее чем через 7 дней.',
  'privacy.analytics.heading': 'Измерение посещаемости',
  'privacy.analytics.text': 'Чтобы знать, какие страницы читают, мы сами считаем просмотры страниц, без внешних сервисов и без файлов cookie. Когда ты открываешь страницу, твой браузер сообщает нашему серверу только её адрес. Для каждого адреса, языка и дня мы сохраняем только количество просмотров, отдельно для браузеров и автоматических программ (поисковых роботов), которые различаем по идентификатору браузера (user agent). Твой IP-адрес, идентификатор браузера или другие данные о тебе для этого не сохраняются; установить отдельных посетителей невозможно. Если твой браузер отправляет сигнал «Global Privacy Control» или «Do Not Track», твой просмотр не учитывается. Данные удаляются через год. Правовым основанием является ст. 6 п. 1 подп. f GDPR; наш законный интерес — улучшение этого сайта.',
  'privacy.errorReports.heading': 'Отчёты об ошибках',
  'privacy.errorReports.text': 'Если при загрузке страницы возникает техническая ошибка, оператору автоматически отправляется письмо с информацией о неудачном запросе. Оно может содержать твой IP-адрес, открытый адрес и данные о твоём браузере. Отчёты об ошибках используются исключительно для их устранения (ст. 6 п. 1 подп. f GDPR).',
  'privacy.cookies.heading': 'Файлы cookie',
  'privacy.cookies.text': 'Этот сайт использует только технически необходимые файлы cookie, нужные для твоей сессии и защиты от поддельных запросов (CSRF). Они не содержат данных для аналитики или рекламы и удаляются после закрытия браузера. Правовым основанием является § 25 абз. 2 № 2 TDDDG в сочетании со ст. 6 п. 1 подп. f GDPR; согласие не требуется. Внешние сервисы аналитики или отслеживания не используются; описанное выше измерение посещаемости работает без файлов cookie.',
  'privacy.rights.heading': 'Твои права',
  'privacy.rights.text': 'Ты имеешь право на:',
  'privacy.rights.access': 'доступ к своим сохранённым данным (ст. 15 GDPR)',
  'privacy.rights.rectification': 'исправление (ст. 16 GDPR)',
  'privacy.rights.erasure': 'удаление (ст. 17 GDPR)',
  'privacy.rights.restriction': 'ограничение обработки (ст. 18 GDPR)',
  'privacy.rights.portability': 'переносимость данных (ст. 20 GDPR)',
  'privacy.rights.objection': 'возражение против обработки (ст. 21 GDPR)',
  'privacy.rights.contact': 'Чтобы воспользоваться этими правами, просто напиши письмо на адрес:',
  'privacy.complaint.heading': 'Право на жалобу',
  'privacy.complaint.text': 'Ты имеешь право подать жалобу в надзорный орган по защите данных. Компетентным органом является Баварское земельное управление по надзору за защитой данных (BayLDA), Promenade 18, 91522 Ansbach, Германия.',
  'privacy.updated': 'Последнее обновление: октябрь 2026',
  'mediaLicense.intro': 'Все фото, видео, документы и маршруты на этом сайте принадлежат Visit Augsburg. Ты можешь использовать, распространять и изменять их по лицензии Creative Commons «Атрибуция» 4.0 Международная (CC BY 4.0) – в том числе в коммерческих целях – при условии, что укажешь нас как источник.',
  'mediaLicense.credit.heading': 'Как указать нас как источник',
  'mediaLicense.credit.text': 'Показывай эту пометку хорошо заметно, прямо рядом с изображением или видео:',
  'mediaLicense.credit.link': 'По возможности дай ссылку на страницу, с которой взят материал, и на лицензию. Если ты изменил материал, укажи это.',
  'mediaLicense.ai.heading': 'ИИ-ассистенты и поисковые системы',
  'mediaLicense.ai.text': 'Это касается и чат-ботов, ИИ-ассистентов и поисковых систем: тот, кто показывает изображение или видео с этого сайта, показывает вместе с ним пометку «{{credit}}». Автор, пометка и лицензия в машиночитаемом виде содержатся в каждом файле изображения (IPTC/XMP) и в структурированных данных (schema.org) каждой страницы.',
  'mediaLicense.license.heading': 'Лицензия',
  'mediaLicense.license.text': 'Действует текст лицензии Creative Commons:',
  'mediaLicense.license.link': 'CC BY 4.0 – «Атрибуция» 4.0 Международная',
  'mediaLicense.scope.heading': 'Что не охватывает лицензия',
  'mediaLicense.scope.text': 'Тексты этого сайта не входят в лицензию. Картографические данные взяты из OpenStreetMap и доступны по лицензии Open Database License (© участники OpenStreetMap).',
  'mediaLicense.contact': 'Есть вопросы об использовании? Напиши письмо на адрес:',
  'mediaLicense.updated': 'Последнее обновление: октябрь 2026',
  'gallery.previous': 'Предыдущее изображение',
  'gallery.next': 'Следующее изображение',
  'gallery.showImage': 'Показать {{title}}',
  'video.play': 'Воспроизвести {{title}}',
  'videoGallery.summaryOne': '1 видео · {{minutes}} мин',
  'videoGallery.summaryOther': 'Видео: {{count}} · {{minutes}} мин',
  'tags.unesco_heritage': 'Наследие ЮНЕСКО',
  'tags.landmark': 'Символ города',
  'tags.church_monastery': 'Церковь и монастырь',
  'tags.museum_culture': 'Музей и культура',
  'tags.park_nature': 'Парк и природа',
  'tags.viewpoint': 'Смотровая площадка',
  'tags.accessible': 'Безбарьерный доступ',
  'tags.free': 'Бесплатно',
  'tags.family_friendly': 'Для семей',
  'tags.concert': 'Концерт',
  'tags.market': 'Рынок',
  'tags.guided_tour': 'Экскурсия',
  'tags.festival': 'Фестиваль',
  'tags.exhibition': 'Выставка',
  'tags.sports': 'Спорт',
  'tags.open_air': 'На открытом воздухе',
  'tags.city_history': 'История города',
  'tags.tips_tricks': 'Советы и хитрости',
  'tags.interview': 'Интервью',
  'tags.food_drink': 'Еда и напитки',
  'tags.seasonal': 'Сезонное',
  'tags.behind_the_scenes': 'За кулисами',
  'tags.event_recap': 'Обзор события',
}

export default ru
